module.exports = __webpack_public_path__ + "img/lg_ring_skip_skip_null_1@2x.0400bbbe.png";